import client from './client';

export interface PushNotification {
  id: number;
  title: string;
  body: string;
  target_type: string | null;
  target_value: string | null;
  sent_count: number;
  created_at: string;
}

export interface PushSendPayload {
  title: string;
  body: string;
  target_type: 'all' | 'district' | 'user';
  target_value?: string;
  data?: Record<string, string>;
}

export interface PushHistoryResponse {
  items: PushNotification[];
  total: number;
  page: number;
  size: number;
}

export const pushApi = {
  send: (data: PushSendPayload) =>
    client.post('/api/admin/push/send', data),

  history: (params?: { page?: number; size?: number }) =>
    client.get<PushHistoryResponse>('/api/admin/push/history', { params }),
};
